<template>
    <div class="step-container" :class="{'tw:border-0': tailwind }">
        <div class="step-header" :class="{'step-disabled': disabled || wizardStore.paymentCompleted, 'tw:bg-zinc-50 tw:rounded-xl': tailwind}" @click="toggleOpen">
            <h3 :class="{'tw:truncate tw:text-sm tw:text-zinc-800': tailwind}">{{ title }}</h3>
            <span class="fa fa-check-circle-o" :class="{'float-right text-success ms-2': !tailwind, 'tw:float-end tw:text-green-600 tw:mr-2': tailwind}" style="line-height: 24px" v-if="stepComplete"></span>
            <span class="fa float-right ms-2" :class="{'fa-caret-down' : !isOpen, 'fa-caret-up': isOpen}" style="line-height: 24px"></span>
        </div>
        <transition
            @enter="startTransition"
            @leave="endTransition"
            @after-enter="afterTransition"
            @after-leave="afterTransition">
            <div class="step-content" v-show="isOpen" ref="content">
                <div class="step-content-inner">
                    <slot></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script setup>
    import {computed} from "vue";
    import {useWizardStore} from "./wizardState";
    const wizardStore = useWizardStore();

    const tailwind = computed(() => wizardStore.tw)

    const emit = defineEmits(['toggle']);

    const props = defineProps({
        title: {
            type: String,
            required: true,
        },
        openStep: {
            type: Number,
            default: null,
        },
        completedSteps: {
            type: Array,
            default: [],
        },
        enabledSteps: {
            type: Array,
            default: [],
        },
        step: {
            type: Number,
            default: null,
            required: true,
        }
    });

    const stepComplete = computed(() => {
        return props.completedSteps.length && props.completedSteps.includes(props.step);
    })

    const isOpen = computed(() => {
        return props.openStep === props.step;
    })

    const disabled = computed(() => {
        return props.enabledSteps.length && !props.enabledSteps.includes(props.step);
    })

    const toggleOpen = () => {
        if (disabled.value || wizardStore.paymentCompleted) {
            return;
        }
        emit('toggle', props.step)
    };

    // Transition hooks
    const startTransition = (el) => {
        el.style.height = '0';
        void el.offsetHeight; // Force reflow
        el.style.height = el.scrollHeight + 'px';
    };

    const endTransition = (el) => {
        el.style.height = el.scrollHeight + 'px';
        void el.offsetHeight; // Force reflow
        el.style.height = '0';
    };

    const afterTransition = (el) => {
        el.style.height = '';
    };
</script>